var map = {
	"./binocular.svg": 1005,
	"./bullit.svg": 1006,
	"./crown.svg": 1007,
	"./crown2.svg": 1008,
	"./earth.svg": 1009,
	"./fire.svg": 1010,
	"./globe.svg": 1011,
	"./group.svg": 1012,
	"./heart.svg": 1013,
	"./hourglass.svg": 1014,
	"./medal.svg": 1015,
	"./sad.svg": 1016,
	"./smile.svg": 1017,
	"./target.svg": 1018,
	"./thunder-move.svg": 1019,
	"./thunder.svg": 1020,
	"./timer.svg": 1021,
	"./trophy-1.svg": 1022,
	"./trophy.svg": 1023,
	"./visible.svg": 1024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;